module.exports = new __parcel__URL__("insight-object-schema-details-sidebar-list-skeleton.tpl.f92d7fb8.svg").toString();